import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { HelpCenterTab } from "components/help/HelpCenterTab";
import { RaiseTicketTab } from "components/help/RaiseTicketTab";
import { MyTicketsTab } from "components/help/MyTicketsTab";

const tabs = [
  { id: "help", label: "Help Center" },
  { id: "raise", label: "Raise a Ticket" },
  { id: "tickets", label: "My Tickets" },
];

export default function HelpPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(
    tabParam === "raise" || tabParam === "tickets" ? tabParam : "help",
  );

  useEffect(() => {
    if (tabParam === "raise" || tabParam === "tickets") {
      setActiveTab(tabParam);
    }
  }, [tabParam]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "help") {
      setSearchParams({});
    } else {
      setSearchParams({ tab });
    }
  };

  return (
    <div
      className="flex flex-col bg-background"
      style={{ width: "85%", height: "91vh", overflowY: "auto" }}
    >
      <div className="flex flex-col h-full px-8 py-6">
        {/* Header */}
        <div className="flex-shrink-0 pb-4">
          <h1 className="text-2xl font-semibold mb-2">Help & Support</h1>
          <p className="text-muted-foreground">
            Get instant help or reach out to our team — we're here for you.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex-shrink-0 flex gap-1 p-1 bg-muted rounded-lg mb-6 w-fit">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              className={`px-6 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${activeTab === tab.id
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground hover:bg-card/50"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-hidden pb-2">
          {activeTab === "help" && <HelpCenterTab />}
          {activeTab === "raise" && (
            <RaiseTicketTab
              onTicketCreated={() => handleTabChange("tickets")}
            />
          )}
          {activeTab === "tickets" && <MyTicketsTab />}
        </div>
      </div>
    </div>
  );
}
